import variables from '../../styles/variables.module.scss';
import casebg from '../../assets/cases/abilia-casebg-2x-min.jpg';

export default {
  path: '/cases/abilia',
  color: variables.abilia,
  description: 'Solutions that make a world of difference',
  casebg,
  case: null,
  isAndroid: true,
  isWeb: false,
  title: 'Handikalender',
  headline: 'Android application',
};
